import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }

import { ref, onMounted } from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'CallbackPage',
  setup(__props) {

    let registered = ref(true);
    let errorMessage = ref<string | null>(null);
    let showVerificationHint = ref(false);

    onMounted(() => {
        // Parse URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const errorDescription = urlParams.get('error_description');

        if (errorDescription) {
            errorMessage.value = decodeURIComponent(errorDescription);
            registered.value = false; // Set `registered` to false to show error message

            // Check if the error message contains "verify"
            if (errorMessage.value.toLowerCase().includes('verify')) {
                showVerificationHint.value = true;
            }
        }
    });

return (_ctx: any,_cache: any) => {
  return (_unref(registered))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Logged in. "))
    : (_unref(errorMessage))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", null, _toDisplayString(_unref(errorMessage)), 1),
          (_unref(showVerificationHint))
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Check the email you used when registering for a verification email. If you do not see this email, please check your spam folders! "))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
}
}

})